import React, { useEffect, useState } from 'react';
import { CButton, CCard, CCardBody, CCardHeader, CCol, CImg, CRow, CSwitch, CTooltip } from '@coreui/react';
import { some, forEach } from 'lodash';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ChatView from './chatView/ChatView';
import LoadingOverlay from '../../shared/components/LoadingOverlay/LoadingOverlay';
import { selectChatState } from '../selectors/chat.selector';
import { getItem, setItem } from '../../shared/utils/local-storage-utils';
import { CHAT_SOUND_NOTIFICATIONS } from '../../shared/constants/chat.constants';
import ContactList from './contacts/ContactList';
import tooltip from '../../assets/images/tool_tip.svg';
import { getLastMessageToken } from '../../shared/utils/chat-utils';
import { ReadAllChats } from '../actions/chat.action';

const Chats = () => {
  const { chatId } = useParams<{chatId?: string}>();
  const history = useHistory();
  const [activeChat, setActiveChat] = useState(null);
  const [notificationsEnabled, setNotificationsEnabled] = useState(false);
  const dispatch = useDispatch();
  const chatState = useSelector(selectChatState);

  useEffect(() => {
    const chatNotifications = getItem(CHAT_SOUND_NOTIFICATIONS);
    if (chatNotifications) {
      setNotificationsEnabled(chatNotifications === 'true');
    }
  }, []);

  useEffect(() => {
    setActiveChat(chatId);
  }, [chatId]);

  const onNotificationsChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event?.target?.checked;
    setNotificationsEnabled(value);
    setItem(CHAT_SOUND_NOTIFICATIONS, `${value}`);
  };

  const changeChatIdHandler = (chatChannel) => {
    setActiveChat(chatChannel);
    history.push(`/chat/${chatChannel}`);
  };

  const dismissAll = () => {
    forEach(chatState?.chats, ((chat) => {
      localStorage.setItem(getLastMessageToken(chat?.chat_id), `${chat?.lastSequenceId || 0}`);
    }));
    dispatch(new ReadAllChats);
  };

  return (
    <CRow>
      <CCol lg='12'>
        <div id="chat-page">
          <CRow>
            <CCol lg="12">
              <CCard className="glympser-container--roundedWithShadow overflow-hidden">
                <CCardHeader className='glympser-roundedTop glympser-bottomBorder d-flex justify-content-between'>
                  Chat
                  <div className="d-flex flex-row">
                    <CButton onClick={dismissAll} variant="ghost" color="light" className="dismiss-all-button mr-2">Dismiss all</CButton>
                    <div className="d-flex align-items-center">
                      Notifications:
                      <CSwitch
                        className="ml-1"
                        onChange={onNotificationsChangeHandler}
                        checked={notificationsEnabled}
                      />
                      <CTooltip placement="top" content="Sound notifications for new messages.">
                        <CImg src={tooltip} className="ml-2 mb-2 glympser-toolTip"/>
                      </CTooltip>
                    </div>
                  </div>
                </CCardHeader>
                <CCardBody className="p-0">
                  {
                    (chatState?.connecting || some(chatState?.chats, chat => chat?.loading)) ? (
                      <div className="d-flex h-100">
                        <LoadingOverlay />
                      </div>
                    ): null
                  }
                  <div className="chat-card-body-inner-container">
                    <ContactList activeChat={activeChat} onSelectChat={changeChatIdHandler}/>
                    <ChatView activeChatId={activeChat}/>
                  </div>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </div>
      </CCol>
    </CRow>
  );
};

export default Chats;
